import { render } from "./StatusCellField.vue?vue&type=template&id=58dc61fe"
import script from "./StatusCellField.vue?vue&type=script&lang=js"
export * from "./StatusCellField.vue?vue&type=script&lang=js"

import "./StatusCellField.vue?vue&type=style&index=0&id=58dc61fe&lang=css"

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"StatusCellField.vue"]])

export default __exports__